import { Estabelecimento } from '@/types/rede-credenciada';
import Image from 'next/image';

interface RedeCredenciadaListCardProps {
  estabelecimento: Estabelecimento;
}

interface EstabelecimentoType {
  label: string;
  img_src: string;
}

const types: EstabelecimentoType[] = [
  { label: '', img_src: '' },
  { label: 'Estacionamento', img_src: '/icons/parking.png' },
  { label: 'Postos de Combustível', img_src: '/icons/fuel.png' },
  { label: 'Pontos de Venda', img_src: '/icons/map-pin.png' },
  { label: 'Pedágios', img_src: '/icons/parking.png' },
  { label: 'Drive-thru', img_src: '/icons/drive-thru.png' },
  { label: 'Lava-rápido', img_src: '/icons/car-wash.png' },
  { label: 'Eletroabaste- cimento', img_src: '/icons/zap.png' },
];

export default function RedeCredenciadaListCard({
  estabelecimento,
}: RedeCredenciadaListCardProps) {
  return (
    <div className="flex flex-row items-center border-2 border-[#E0E0E0] rounded-2xl p-4 w-full h-[164px] shadow-sm">
      {/* Lado esquerdo */}
      <div className="flex flex-col items-center w-32 justify-center pr-4 border-r-2 border-[#E0E0E0] h-[92px]">
        <Image
          src={types[estabelecimento.tipo].img_src}
          alt="Ícone do tipo de estabelecimento"
          width={48}
          height={48}
          className="mb-1"
        />
        <p className="text-base font-bold text-bluecaixa text-center">
          {types[estabelecimento.tipo].label}
        </p>
      </div>

      {/* Lado direito */}
      <div className="flex flex-col justify-center gap-3 pl-4 flex-1">
        {/* Tag de distância */}
        <span className="self-start border border-green-600 bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-md mb-1">
          {estabelecimento.distancia_km} km
        </span>

        {/* Nome do estabelecimento */}
        <h1 className="text-bluecaixa text-lg font-bold leading-tight">
          {estabelecimento.nome}
        </h1>

        {/* Endereço */}
        <p className="text-[#464646] text-sm">{estabelecimento.endereco}</p>
      </div>
    </div>
  );
}
